export default "__VITE_ASSET__iXF58TbH__"